export default __webpack_public_path__ + "static/media/45k.e8ed6c17.md";